import './App.css';
import Landing from './Landing/landingPage';
import Number from './Number/number';

function App() {
  return (
    <Landing />
  );
}

export default App;
